import platformApi from "../../../axios";

export function requestUserList(role,params,data) {
    return platformApi({
        url: '/personnel/page/'+role,
        method: 'post',
        params: params,
        data: data
    })
}
export function requestCustomerList(params,data) {
    return platformApi({
        url:'/delivery/transfer/customer/page',
        method:'post',
        data:data,
        params:params,
    })
}
